export default {

    getCssVar(name) {
        return getComputedStyle(document.body).getPropertyValue(name);
    }

}


// WEBPACK FOOTER //
// ./src/js/globals.js